// extracted by mini-css-extract-plugin
export default {"codes":"PinCodeInput_codes__R-gc-","code":"PinCodeInput_code__wX5qk"};